module.exports = __webpack_public_path__ + "img/ltkfindsunder100-2x.038b5c4.jpg";